import * as React from 'react'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { cn } from '@/lib/utils'

// Thin wrapper over the raw shadcn Button adding a `loading` state.
// Brand color comes from the `default` variant token (bg-primary), no `color` prop.
export type OdinButtonProps = React.ComponentProps<typeof Button> & {
  loading?: boolean
}

// Wrapper-only size scale (taller than the raw cva sizes) so buttons don't read as too thin.
// tailwind-merge (via cn()) resolves the h-*/px-* conflict against the raw cva classes.
const sizeOverrides: Partial<Record<NonNullable<OdinButtonProps['size']>, string>> = {
  default: 'h-10 px-4',
  sm: 'h-8 px-3',
}

export function OdinButton({ loading, disabled, children, className, size = 'default', ...props }: OdinButtonProps) {
  return (
    <Button size={size} disabled={disabled || loading} className={cn(sizeOverrides[size ?? 'default'], className)} {...props}>
      {loading ? <Spinner aria-hidden /> : children}
    </Button>
  )
}
